/** px → mm בהנחת 96 DPI (דפדפן) */
const PX_TO_MM = 25.4 / 96

/**
 * שמירת קנבס כקובץ PDF (דינמי jspdf).
 * @param {HTMLCanvasElement} canvas
 * @param {{ filename?: string, pageSize?: 'image' | 'a4', marginMm?: number }} [opts]
 *   - image: עמוד בגודל המדויק של התמונה (פיקסלים כיחידות jsPDF)
 *   - a4: התאמה למרכז עמוד A4 להדפסה
 */
export async function downloadCanvasAsPdf(canvas, opts = {}) {
  if (!canvas?.width || !canvas?.height) throw new Error('Invalid canvas')
  const pageSize = opts.pageSize ?? 'a4'
  const marginMm = Math.max(0, Number(opts.marginMm) || 10)
  const filename = opts.filename ?? `colorphoto-${Date.now()}.pdf`
  const { jsPDF } = await import('jspdf')

  const wPx = canvas.width
  const hPx = canvas.height
  const pxCount = wPx * hPx
  const useJpeg = pxCount > 10_000_000
  const imgData = useJpeg ? canvas.toDataURL('image/jpeg', 0.92) : canvas.toDataURL('image/png')
  const imgFormat = useJpeg ? 'JPEG' : 'PNG'

  if (pageSize === 'image') {
    const pdf = new jsPDF({
      orientation: wPx > hPx ? 'landscape' : 'portrait',
      unit: 'px',
      format: [wPx, hPx],
      compress: true,
    })
    pdf.addImage(imgData, imgFormat, 0, 0, wPx, hPx)
    pdf.save(filename)
    return
  }

  const imgMmW = wPx * PX_TO_MM
  const imgMmH = hPx * PX_TO_MM
  const orientation = imgMmW >= imgMmH ? 'landscape' : 'portrait'
  const pdf = new jsPDF({ orientation, unit: 'mm', format: 'a4', compress: true })
  const pageW = pdf.internal.pageSize.getWidth()
  const pageH = pdf.internal.pageSize.getHeight()
  const maxW = pageW - 2 * marginMm
  const maxH = pageH - 2 * marginMm
  const scale = Math.min(maxW / imgMmW, maxH / imgMmH)
  const drawW = imgMmW * scale
  const drawH = imgMmH * scale
  const x = (pageW - drawW) / 2
  const y = (pageH - drawH) / 2
  pdf.addImage(imgData, imgFormat, x, y, drawW, drawH)
  pdf.save(filename)
}
